export default "__VITE_ASSET__CYlqxaxQ__"